import { camelCase } from "lodash";

const flatten = (object) => {
  const result = {};

  Object.keys(object).map((key) => {
    if (typeof object[key] === "object" && object[key] !== null) {
      const flatObject = flatten(object[key]);

      Object.keys(flatObject).map((flatkey) => {
        result[`${key}.${flatkey}`] = flatObject[flatkey];
      });
    } else {
      result[key] = object[key];
    }
  });

  return result;
};

const split = (string) => {
  if (string.includes(".")) {
    return string.split(".")[1];
  }

  return string;
};

const replacer = (string) => {
  switch (string) {
    case "user":
      return "you";
    case "client":
      return "business";
    default:
      return string;
  }
};

const remapper = (keys, data) => {
  const dataKeys = Object.keys(data);

  const cache = {};

  dataKeys.map((dk) => {
    const parent = keys.find((k) => dk.includes(k));

    if (!Array.isArray(cache[parent])) {
      cache[parent] = [];
    }

    const label = camelCase(split(dk));

    cache[parent].push({
      label: label.toUpperCase(),
      value: `{{${dk}}}`,
    });
  });

  return cache;
};

const formatted = (data) => {
  const keys = Object.keys(data);

  const result = keys.map((key) => {
    const label = replacer(key);
    return { label: label.toUpperCase(), options: data[key] };
  });

  return result;
};

export const format = (object) => {
  const flat = flatten(object);

  const keys = Object.keys(object);

  const remapped = remapper(keys, flat);

  const result = formatted(remapped);

  return result;
};

export default flatten;
